import React from 'react';
import Link from 'react-router-dom/Link';

export default class ResetPasswordForm2 {
	constructor(app){
		this.app = app;
		this.reset();
	}

	reset(){
		this.username = '';
		this.password = '';
		this.confirmPassword = '';
		this.resetCode = '';
		this.loading = false;
		this.errorMessage = '';
	}

	async submit(){
		this.app.startLoadingForm(this);
		try{
			this.app.validate(this.password === this.confirmPassword, 'Passwords must match.');
			this.app.validate(this.password && this.password.length >= 6, 'Passwords must be at least 6 characters long.');

			await this.app.http.confirmPasswordReset({
				username:this.username,
				password:this.password,
				confirmationCode: this.resetCode
			});

			this.reset();
			this.app.logout(false);
			this.app.forceUpdate();

			this.app.goToMessagePage({
				title: 'Your password has been updated!',
				body: (<div>Your password has been updated. <Link to="/login">Click here to login</Link>.</div>)
			});
		}catch(e){
			this.app.stopLoadingForm(this, e);
		}
	}
}



// WEBPACK FOOTER //
// ./src/models/ResetPasswordForm2.js